import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
}

const iconProps = (size: number) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
});

export const DownloadIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

export const MenuIcon = ({ size = 24, className }: IconProps) => (
  <svg {...iconProps(size)} className={className}>
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

export const CloseIcon = ({ size = 24, className }: IconProps) => (
  <svg {...iconProps(size)} className={className}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const SunIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className}>
    <circle cx="12" cy="12" r="5" />
    <line x1="12" y1="1" x2="12" y2="3" />
    <line x1="12" y1="21" x2="12" y2="23" />
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
    <line x1="1" y1="12" x2="3" y2="12" />
    <line x1="21" y1="12" x2="23" y2="12" />
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
  </svg>
);

export const MoonIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className}>
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

export const ChevronDownIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export const CodeIcon = ({ size = 24, className }: IconProps) => (
  <svg {...iconProps(size)} className={className}>
    <polyline points="16 18 22 12 16 6" />
    <polyline points="8 6 2 12 8 18" />
  </svg>
);

export const CloudIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="currentColor" stroke="none">
    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
  </svg>
);

export const StorageIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <ellipse cx="12" cy="5" rx="9" ry="3" />
    <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
    <path d="M3 12c0 1.66 4 3 9 3s9-1.34 9-3" />
  </svg>
);

export const AutoGraphIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <path d="M18 20V10" />
    <path d="M12 20V4" />
    <path d="M6 20v-6" />
  </svg>
);

export const LinkedInIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="currentColor" stroke="none">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect x="2" y="9" width="4" height="12" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);

export const GitHubIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="currentColor" stroke="none">
    <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77 5.44 5.44 0 0 0 1.5 9.64c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 7 18.13V22" />
  </svg>
);

export const ArticleIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

export const SettingsSuggestIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  </svg>
);

export const SchoolIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
    <path d="M6 12v5c3 3 9 3 12 0v-5" />
  </svg>
);

export const EventIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

export const VerifiedIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

export const EmailIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

export const BusinessCenterIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
  </svg>
);

export const HdrStrongIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <path d="M6 4v16M18 4v16M9 9h6v6H9z" />
  </svg>
);

export const CalendarTodayIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

export const ArrowBackIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className}>
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);

export const LaunchIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

export const ArrowBackIosNewIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className}>
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

export const ArrowForwardIosIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className}>
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

export const FormatQuoteIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="currentColor" stroke="none">
    <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V21zM15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" />
  </svg>
);

export const BarChartIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
  </svg>
);

export const WebIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

export const DevicesIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
    <line x1="12" y1="18" x2="12" y2="18.01" />
  </svg>
);

export const AutoStoriesIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
);

export const PsychologyIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2z" />
    <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2z" />
  </svg>
);

export const PersonIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="currentColor" stroke="none">
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
  </svg>
);

export const LinkIcon = ({ size = 20, className }: IconProps) => (
  <svg {...iconProps(size)} className={className} fill="none">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);
